import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/landing/gifs/create_app.gif")